var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Navbar"),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            {
              staticClass: "settings-message",
              style: { opacity: _vm.showAlert ? 1 : 0 }
            },
            [
              _c("span", { staticClass: "alert alert-success" }, [
                _vm._v("Public draw settings updated.")
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12 d-flex align-items-center page-header" },
              [
                _c(
                  "a",
                  {
                    staticClass: "header-action",
                    on: {
                      click: function($event) {
                        return _vm.goToDashboard()
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "header-action back",
                      attrs: { src: require("@/assets/images/x.svg") }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("h1", [_vm._v("PUBLIC DRAW SETTINGS")]),
                _vm._v(" "),
                _c("div", { staticClass: "desktop" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary save",
                      attrs: { disabled: this.waitSave },
                      on: { click: _vm.saveSettings }
                    },
                    [_vm._v("Save")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 d-flex" }, [
              _c("div", { staticClass: "title" }, [
                _c("p", [_vm._v("Show/Hide on Public Draw screen")]),
                _vm._v(" "),
                _c("label", { staticClass: "check-container" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: this.prize },
                    on: { change: _vm.handlePrizeCheck }
                  }),
                  _vm._v(" "),
                  _c("b", { staticClass: "label-text" }, [
                    _vm._v("Prize Name")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkmark" })
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "check-container" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.winner },
                    on: { change: _vm.handleWinnerCheck }
                  }),
                  _vm._v(" "),
                  _c("b", { staticClass: "label-text" }, [
                    _vm._v("Winner Position")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkmark" })
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "check-container" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: this.spin },
                    on: { change: _vm.handleSpinCheck }
                  }),
                  _vm._v(" "),
                  _c("b", { staticClass: "label-text" }, [
                    _vm._v("Spin/Skip Buttons")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkmark" })
                ]),
                _vm._v(" "),
                !this.spin
                  ? _c("div", { staticClass: "spin-instructions" }, [
                      _c("p", [_vm._v("Button Guide: ")]),
                      _vm._v(" "),
                      _vm._m(0)
                    ])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 d-flex" }, [
              _c("div", { staticClass: "title" }, [
                _c("p", [
                  _vm._v(
                    "\n              Upload Custom Background Image\n              "
                  ),
                  _c("span", { staticClass: "change-btn-wrapper" }, [
                    _c("a", [_vm._v("change")]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "file", accept: "image/*" },
                      on: { change: _vm.previewBgImage }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm.backgroundUrl === ""
                  ? _c("div", { staticClass: "upload-btn-wrapper" }, [
                      _c("button", { staticClass: "upload-btn" }, [
                        _vm._v("+")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "file", accept: "image/*" },
                        on: { change: _vm.previewBgImage }
                      })
                    ])
                  : _c("div", [
                      _c("b", { staticClass: "uploaded-image" }, [
                        _vm._v(_vm._s(_vm.backgroundUrl))
                      ])
                    ]),
                _vm._v(" "),
                _vm._m(1)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 d-flex" }, [
              _c("div", { staticClass: "title" }, [
                _c("p", [
                  _vm._v(
                    "\n              Upload Custom Image for Thank you Page\n              "
                  ),
                  _c("span", { staticClass: "change-btn-wrapper" }, [
                    _c("a", [_vm._v("change")]),
                    _vm._v(" "),
                    _c("input", {
                      attrs: { type: "file", accept: "image/jpeg, image/png" },
                      on: { change: _vm.previewThankImage }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm.thankyouUrl === ""
                  ? _c("div", { staticClass: "upload-btn-wrapper" }, [
                      _c("button", { staticClass: "upload-btn" }, [
                        _vm._v("+")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "file",
                          accept: "image/jpeg, image/png"
                        },
                        on: { change: _vm.previewThankImage }
                      })
                    ])
                  : _c("div", [
                      _c("b", { staticClass: "uploaded-image" }, [
                        _vm._v(_vm._s(_vm.thankyouUrl))
                      ])
                    ]),
                _vm._v(" "),
                _vm._m(2)
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 d-flex" }, [
              _c("div", { staticClass: "title" }, [
                _c("p", [_vm._v("Spinning Field (Spin Using)")]),
                _vm._v(" "),
                _c("div", { staticClass: "spin-dropdown-container dropdown" }, [
                  _c("div", { attrs: { "data-toggle": "dropdown" } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-control spinning-field-label",
                        attrs: {
                          "aria-haspopup": "true",
                          "aria-expanded": "false"
                        }
                      },
                      [_vm._v(_vm._s(_vm.computedSpinningField))]
                    ),
                    _vm._v(" "),
                    _vm._m(3)
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu list-container",
                      attrs: { "aria-labelledby": "dropdownMenuButton" }
                    },
                    [
                      _vm._l(_vm.allAttendeeFields, function(field, index) {
                        return [
                          field.data_type === "string"
                            ? _c(
                                "li",
                                {
                                  key: index,
                                  on: {
                                    click: function($event) {
                                      return _vm.chooseItem(field)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(field.label))]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mobile" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary save",
                attrs: { disabled: this.waitSave },
                on: { click: _vm.saveSettings }
              },
              [_vm._v("Save")]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("p", [_c("b", [_vm._v("Escape")]), _vm._v(": Cancels Draw")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("p", [_c("b", [_vm._v("Space Bar")]), _vm._v(": Starts Draw")])
      ]),
      _vm._v(" "),
      _c("li", [_c("p", [_c("b", [_vm._v("A")]), _vm._v(": Skips Draw")])]),
      _vm._v(" "),
      _c("li", [
        _c("p", [_c("b", [_vm._v("S")]), _vm._v(": Respins Current Draw")])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("p", [_c("b", [_vm._v("D")]), _vm._v(": Moves On Current Winner")])
      ]),
      _vm._v(" "),
      _c("li", [_c("p", [_c("b", [_vm._v("C")]), _vm._v(": Confirms Winner")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-upload-text" }, [
      _vm._v(
        "*Please upload an image which is at least 1280 px X 800 px in dimension. Max file upload size is 4MB\n              "
      ),
      _c("br"),
      _vm._v("**supported formats are .jpg and .png\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-upload-text" }, [
      _vm._v(
        "*Please upload an image which is at least 1280 px X 800 px in dimension. Max file upload size is 4MB\n              "
      ),
      _c("br"),
      _vm._v("**supported formats are .jpg and .png\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "caret-container" }, [
      _c("img", { attrs: { src: require("@/assets/images/caret.svg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97729680", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97729680","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublicDrawSettings.vue
// module id = null
// module chunks = 